import React from 'react';
import OutputsExport from './OutputsExport';
import InterviewQuestionsAccordion from './interview/InterviewQuestionsAccordion';

const OutputsSection = () => {
  return (
    <div className="max-w-5xl mx-auto space-y-8">
      <OutputsExport />
      <InterviewQuestionsAccordion />
    </div>
  );
};

export default OutputsSection; 